
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'preizkus',
	'visualizationSlideoutTitle': 'Vizualizacije',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Vnesite število',
	'maxValuePlaceholder': 'Vnesite število',
	'customRangeErrorMessage': 'Vrednost mora biti število',
	'propFillColor': 'Barva polnila',
	'propBorderColor': 'Barva obrobe',
	'propColorPalette': 'Trenutna barvna paleta',
	'propColorPaletteChangeLabel': 'Spremeni barvno paleto',
	'propNewColorPaletteLabel': 'Ustvari barvno paleto po meri',
	'propNewHeatPaletteLabel': 'Ustvari toplotno paleto po meri',
	'propDonutRadius': 'Polmer kolobarja',
	'showTitleLabel': 'Pokaži naslov',
	'titleTypeLabel': 'Tip naslova',
	'smartTitleLabel': 'Pametni naslov',
	'customTitleLabel': 'Naslov po meri',
	'noTitleLabel': 'Brez naslova',
	'propHeatScalePalette': 'Trenutna toplotna paleta',
	'propHeatPaletteChangeLabel': 'Spremeni toplotno paleto',
	'propMaintainAxisScales': 'Ohrani merilo osi',
	'propLineAndSymbolColor': 'Barva črt in simbolov',
	'propLineAndSymbolPalette': 'Barvna paleta črt in simbolov',
	'propElementColor': 'Barva elementa',
	'propColumnColor': 'Barva stolpca',
	'propColumnPalette': 'Barvna paleta stolpca',
	'propColumnHeatPalette': 'Toplotna paleta stolpca',
	'propBarColor': 'Barva palic',
	'propGoalColor': 'Ciljna barva',
	'propToColor': 'Do barve',
	'propFromColor': 'Od barve',
	'propNumberValidationErrorMessageId': 'Vnesite število',
	'fontSizeAuto': 'Samodejno',
	'propAutoBinCount': 'Število skupin',
	'propAutoBinToggle': 'Samodejno grupiranje',
	'tabName_general': 'Splošno',
	'tabName_visDetails': 'Podrobnosti',
	'tabName_animation': 'Animacija',
	'tabName_mediaDetails': 'Podrobnosti medija',
	'tabName_webDetails': 'Podrobnosti spletne strani',
	'tabName_imageDetails': 'Podrobnosti slike',
	'tabName_visualization': 'Vizualizacija',
	'tabName_text': 'Besedilo',
	'sectionName_colorsAndThemes': 'Barva in teme',
	'sectionName_appearance': 'Videz',
	'sectionName_general': 'Splošno',
	'sectionName_colorPalette': 'Barva',
	'sectionName_axis': 'Os',
	'sectionName_axis_label': 'Os',
	'sectionName_legend': 'Legenda',
	'sectionName_chart': 'Grafikon',
	'sectionName_regionLayer': 'Plast regij',
	'sectionName_pointLayer': 'Plast točk',
	'sectionName_latLongLayer': 'Plast geografske širine/geografske dolžine',
	'sectionName_pathLayer': 'Plast poti',
	'sectionName_xAxis': 'Os X',
	'sectionName_yAxis': 'Os Y',
	'sectionName_xAxis_title': 'Naslov osi X',
	'sectionName_yAxis_title': 'Naslov osi Y',
	'sectionName_xAxis_label': 'Oznaka osi X',
	'sectionName_yAxis_label': 'Oznaka osi Y',
	'sectionName_column_yAxis': 'Os Y stolpca',
	'sectionName_column_yAxis_label': 'Oznaka osi Y stolpca',
	'sectionName_column_yAxis_title': 'Naslov osi Y stolpca',
	'sectionName_line_yAxis': 'Os Y vrstice',
	'sectionName_line_yAxis_label': 'Oznaka osi Y vrstice',
	'sectionName_line_yAxis_title': 'Naslov osi Y vrstice',
	'sectionName_title': 'Naslov',
	'sectionName_dataValueLabels': 'Oznake vrednosti podatkov',
	'sectionName_style': 'Slog',
	'propTransparencyDescription': 'Prilagodite objekt tako, da bo bolj ali manj prosojen. Vnesite vrednost med 0 in 100.',
	'smart_annotation_unauthorized': 'Pripombe: nepooblaščen dostop',
	'smart_annotation_method': 'Pripombe: metoda ni dovoljena',
	'smart_annotation_media': 'Pripombe: tip medija ni dovoljen',
	'smart_annotation_input': 'Pripombe: neveljaven vnos',
	'smart_annotation_internal': 'Pripombe: notranja sistemska napaka',
	'smart_annotation_generic_error': 'Pripombe: napaka v storitvi',
	'smart_annotation_dialog_title': 'Vpogledi',
	'smart_annotation_Show_Insights': 'Pokaži vpoglede',
	'smart_annotation_Relationship': 'Razmerje je',
	'forecast_enter_number': 'Vnesite število med ',
	'and': ' in ',
	'smart_errors': 'Napake pripomb:',
	'smart_warnings': 'Opozorila pripomb:',
	'smart_annotation_insight_icon_title': 'Vpogledi',
	'smart_annotations_toggle_on': 'Vklopi vpoglede',
	'smart_annotations_toggle_off': 'Izklopi vpoglede',
	'smart_annotation_toggle_on': 'Vklopi',
	'smart_annotation_toggle_off': 'Izklopi',
	'smart_annotation_insight_unavailable': 'Vpogledi trenutno niso na voljo',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Vpogledi niso na voljo, če je uporabljen filter % Zgoraj ali Spodaj',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Napoved ni na voljo, če je uporabljen filter % Zgoraj ali Spodaj',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Vpogledi niso na voljo, ko je uveljavljen zgornji ali spodnji filter in je v polju več kot en stolpec',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Napoved ni na voljo, ko je uveljavljen zgornji ali spodnji filter in je v polju več kot en stolpec',
	'forecast_title': 'Napoved',
	'forecast_show': 'Pokaži napoved',
	'forecast_toggle_on': 'Vklopi napovedovanje',
	'forecast_toggle_off': 'Izklopi napovedovanje',
	'statDetailsPerspectiveTitle': 'Analiza',
	'emptyStatDetailsPanel': 'Za trenutno vizualizacijo ni na voljo nobena dodatna analiza.',
	'predict_errors': 'Napake analize',
	'predict_warnings': 'Opozorila analize',
	'fpd_invalid_data_source': 'Ta izvor podatkov nima povezanega pametnega modula',
	'fpd_network_issue': 'Med izvajanjem analize za ta izvor podatkov je prišlo do težave',
	'fpd_data_source_category': 'Pametni modul manjka',
	'fpd_response_errors': 'Napake priporočenega gonilnika',
	'fpd_response_warnings': 'Opozorila priporočenega gonilnika',
	'catalyst_service_bad_request': 'Neveljavna zahteva',
	'catalyst_service_unkown_Id': 'Najden neznan ID zahteve',
	'catalyst_service_internal_server_error': 'Notranja napaka strežnika',
	'catalyst_service_generic_error': 'Napaka storitve Catalyst',
	'catalyst_service_error': 'Ta storitev trenutno ni na voljo',
	'propLegendPosition': 'Položaj legende',
	'propLeft': 'Levo',
	'propRight': 'Desno',
	'propTop': 'Zgoraj',
	'propBottom': 'Spodaj',
	'propNone': 'Brez',
	'propLegendDisplay': 'Prikaži legendo',
	'targetThicknessPlaceHolder': '%{min} do %{max}',
	'targetThicknessErrorMsg': 'Vnesite celo število med %{min} in %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Gonilniki (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'izbrani)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Ponastavi na privzete vrednosti',
	'possibelKeyDriver_AddNewDrivers': 'Dodaj več gonilnikov',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Iščite, da dodate več gonilnikov',
	'possibleKeyDrivers_MaxPossibleReached': 'Razveljavite izbiro nekaterih gonilnikov, da dodate ali izberete druge',
	'possibleKeyDrivers_Recommended': 'Priporočeno',
	'visRecommendedTypes': 'Priporočeni tipi vizualizacij',
	'visRecommender_smartsfailure': 'Priporočila vizualizacije trenutno niso na voljo',
	'visMore': 'Dodatne možnosti ...',
	'visMoreTooltip': 'Več vizualizacij',
	'visOtherTypes': 'Drugi tipi vizualizacij',
	'visChange': 'Spremeni vizualizacijo',
	'automaticTypeCaption': 'Samodejno',
	'propVisType': 'Tipi vizualizacije',
	'dlg_loading': 'Nalaganje ...',
	'snippetListChartCaption': 'Seznam izrezkov',
	'convoClusterChartCaption': 'Gruča pogovorov',
	'areaChartCaption': 'Področni',
	'barChartCaption': 'Palični grafikon',
	'columnChartCaption': 'Stolpec',
	'stackedbarChartCaption': 'Strukturni palični grafikon',
	'stackedcolumnChartCaption': 'Strukturni stolpčni grafikon',
	'bubbleChartCaption': 'Mehurčni',
	'marimekkoChartCaption': 'Grafikon Marimekko',
	'cometChartCaption': 'Analiza gonilnikov',
	'scatterChartCaption': 'Raztreseni grafikon',
	'lineChartCaption': 'Črtni',
	'pointChartCaption': 'Točkovni grafikon',
	'heatChartCaption': 'Toplotni grafikon',
	'bulletChartCaption': 'Večlični palični',
	'waterfallChartCaption': 'Mostovni grafikon',
	'radarChartCaption': 'Radarski grafikon',
	'boxplotChartCaption': 'Škatlasti',
	'pieChartCaption': 'Tortni grafikon',
	'mapChartCaption': 'Zemljevid',
	'radialBarChartCaption': 'Radialni',
	'compositeChartCaption': 'Črtni in stolpčni grafikon',
	'wordCloudChartCaption': 'Besedni oblak',
	'networkChartCaption': 'Omrežje',
	'relationshipNetworkChartCaption': 'Omrežje razmerij',
	'treemapChartCaption': 'Mozaični graf',
	'packedBubbleChartCaption': 'Strnjeni mehurčni grafikon',
	'hierarcicalPackedBubbleChartCaption': 'Hierarhični mehurčni grafikon',
	'spiralChartCaption': 'Spiralni grafikon',
	'decisionTreeChartCaption': 'Odločitveno drevo',
	'legacyMapChartCaption': 'Zemljevid starejše različice',
	'sunburstChartCaption': 'Večstopenjski tortni grafikon',
	'visUsageComparison': 'Primerjava',
	'visUsageRelationships': 'Razmerja',
	'visUsageTrend': 'Trendni',
	'visUsagePartsToWhole': 'Deli do celote',
	'visUsageGeospatial': 'Geoprostorski',
	'visUsageAdvanced': 'Napredna analitika',
	'visUsageTablesAndSummary': 'Tabele in povzetek',
	'visUsageSocialInsights': 'Družabni vpogledi',
	'visUsageOther': 'Drugo',
	'autoBinActionText': 'Samodejno grupiranje',
	'filterAutobinActionText': 'Predali filtra',
	'memberCalculationActionText': 'Izračun člana',
	'toolbarActionCalculation': 'Ustvari izračun',
	'toolbarActionEditCalculation': 'Urejanje izračuna',
	'topBottomRankLabel': 'Rang (%{label})',
	'toolbarDeleteFilterActionText': 'Odstrani filter',
	'toolbarActionTopKeyDrivers': 'Pokaži gonilnike',
	'toolbarActionCustomGroup': 'Skupina po meri',
	'canNotCreateCustomGroup': 'Te skupine po meri ni mogoče ustvariti.',
	'aria_label_datatable': 'Podatkovna tabela',
	'summaryCaption': 'Seštevek',
	'MeasuresCaption': 'Mere',
	'MeasuresGroupCaption': 'Skupina mer (%{count})',
	'ValuesCaption': 'Vrednosti',
	'turnInsightsOn': 'Vklopi vpoglede',
	'turnInsightsOff': 'Izklopi vpoglede',
	'decisionRules': 'Pravila',
	'decisionTree': 'Drevesni diagram',
	'decisionSunburst': 'Drevesni večstopenjski tortni',
	'switchToDecisionRules': 'Preklopi na odločitvena pravila',
	'switchToDecisionTree': 'Preklopi na odločitveno drevo',
	'data_group_less_then': 'manj kot %{rangeTo}',
	'data_group_to': '%{rangeFrom} do < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} in več',
	'nullValueContent': '(brez vrednosti)',
	'sum': 'Vsota',
	'count': 'Število',
	'countdistinct': 'Razlikovalno štetje',
	'avg': 'Povprečno',
	'min': 'Minimum',
	'max': 'Maksimum',
	'automatic': 'Po meri',
	'variance': 'Varianca',
	'stddev': 'Standardni odklon',
	'median': 'Mediana',
	'calculated': 'Izračunano',
	'none': 'Brez',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Vrednosti poziva',
	'inputLabelPrompt': 'Vrednost',
	'inputPlaceholderPrompt': 'Vnesite vrednost',
	'inputInvalidText': 'Neveljaven vnos za tip %{dataType}',
	'unSupportedPrompt': 'Nepodprt poziv',
	'missingDataSource': 'Pravega izvora podatkov ni bilo mogoče najti.',
	'unSupportedPromptType': 'Scenarij s pozivi trenutno ni podprt.',
	'preAggregateLabel': 'Uveljavi vrednosti poziva iz izvora podatkov',
	'postAggregateLabel': 'Uveljavi vrednosti poziva v poročilu',
	'preAggregateText': 'Obseg uporablja vrednosti v izvoru podatkov, ne vrednosti, ki so prikazane na delovni tabli.',
	'defaultAggregation_count': 'Število',
	'defaultAggregation_countdistinct': 'Razlikovalno štetje',
	'defaultAggregation_max': 'Maksimum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Povprečno',
	'defaultAggregation_sum': 'Vsota',
	'defaultAggregation_auto': 'Samodejno (%{aggregationType})',
	'keydriver_average': 'Splošno povprečje',
	'keydriver_up_down': 'Označene skupine z visokimi ali nizkimi povprečji bolj vplivajo na cilj. Skupine z neobičajno visokimi ali nizkimi povprečji imajo najmočnejši vpliv.',
	'keydriver_different': 'Označene skupine imajo distribucije, ki se občutno razlikujejo od celotne distribucije. Te skupine bolj vplivajo na cilj.',
	'topOperator': 'Zgoraj',
	'bottomOperator': 'Spodaj',
	'topBottomFact': '%{operator} %{value}%{percent} po %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Izbriši število zgornjih ali spodnjih',
	'deleteTopBottomPercent': 'Izbriši % zgornjih ali spodnjih',
	'topBottomTitle': 'Samo ta objekt',
	'deleteTopBottom': 'Izbriši število zgornjih ali spodnjih',
	'editTopBottom': 'Urejanje števila zgornjih ali spodnjih',
	'editTopBottomCount': 'Urejanje števila zgornjih ali spodnjih',
	'editTopBottomPercent': 'Urejanje % zgornjih ali spodnjih',
	'ariaDeleteTopBottomCountLabel': 'Pritisnite tipko DELETE, da izbrišete število zgornjih ali spodnjih.',
	'ariaDeleteTopBottomPercentLabel': 'Pritisnite tipko DELETE, da izbrišete % zgornjih ali spodnjih.',
	'ariaEditTopBottomCountLabel': 'Pritisnite tipko ENTER, da uredite število zgornjih ali spodnjih.',
	'ariaEditTopBottomPercentLabel': 'Pritisnite tipko ENTER, da uredite % zgornjih ali spodnjih.',
	'ariaDeleteDrillStateLabel': 'Pritisnite tipko ENTER, da uredite število zgornjih ali spodnjih.',
	'drillUpStateTitle': 'Vrtaj navzgor',
	'drillDownStateTitle': 'Vrtaj navzdol',
	'ariaEditTopBottomLabel': 'Pritisnite tipko ENTER, da uredite število zgornjih ali spodnjih.',
	'ariaDeleteTopBottomLabel': 'Pritisnite tipko DELETE, da izbrišete število zgornjih ali spodnjih.',
	'allKeyDriversLabel': 'Samodejno (vsi gonilniki)',
	'filter_drag_and_drop_single_dock': 'Povlecite in spustite podatke sem, da filtrirate.',
	'filter_drag_and_drop_all_tabs': 'Povlecite in spustite podatke sem, da filtrirate vse zavihke.',
	'filter_drag_and_drop_current_tab': 'Povlecite in spustite podatke sem, da filtrirate ta zavihek.',
	'filter_empty_consume_mode': 'Noben filter ni bil uveljavljen.',
	'filterClearAllItems': 'Počisti vse filtre',
	'filterDeleteAllItems': 'Izbriši vse filtre',
	'filterDockChevronLeft': 'Pomakni se prek podatkov',
	'filterDockChevronRight': 'Pomakni se prek podatkov',
	'filterIconLabel_Single': 'Filtri',
	'filterIconLabel_Global': 'Vsi zavihki',
	'filterIconLabel_Tab': 'Ta zavihek',
	'filterIconTooltip_Single': 'Filtri',
	'filterIconTooltip_Global': 'Filtri za vse zavihke',
	'filterIconTooltip_Tab': 'Filtri za ta zavihek',
	'filterDropZoneTooltip_Single': 'Spustno območje filtra',
	'filterDropZoneTooltip_Global': 'Spustno območje filtra za vse zavihke',
	'filterDropZoneTooltip_Tab': 'Spustno območje filtra za ta zavihek',
	'filterOverflowMenu': 'Več',
	'expand': 'Razširi',
	'collapse': 'Strni',
	'filterDockItemNameAriaLabel': 'Pritisnite Enter, da zaženete pogovorno okno filtra in definirate filter.',
	'filterItemCanvasMove': 'Dodaj na platno',
	'filterItemDelete': 'Izbriši filter',
	'filterInvertRange': 'vse razen: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Ni po %{from}',
	'filter_date_after': 'Po %{from}',
	'filter_date_before_except': 'Ni pred %{to}',
	'filter_date_before': 'Pred %{to}',
	'filter_date_between_except': 'Ni med %{from}-%{to}',
	'filter_date_between': 'Med %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Vse',
	'filter': 'Filter',
	'filterExcept': 'razen %{values}',
	'filterDockToolbarButtonLabel': 'Zasidranje filtra',
	'navigateTitle': 'Pomik v',
	'navigateSelectColumn': 'Izberi stolpec',
	'navigateSelectPath': 'Izberite navigacijsko pot',
	'current_nav_group': 'Trenutna navigacijska skupina je %{navigation_group_name}',
	'next': 'Naprej',
	'previous': 'Nazaj',
	'multiselectMsg': 'Izbrano: %{count}',
	'errMsgFilterItemMissingTitle': 'Vrednosti filtra %{itemName} ni mogoče naložiti, ker te vrednosti niso na voljo s tem naborom podatkov',
	'errMsgFilterItemGenericTitle': 'Vrednosti filtrov ni mogoče naložiti',
	'textFilterItemsNotFound': 'Na voljo ni nobene postavke.',
	'nullValueLabel': '(prazno)',
	'filterConditionLabel': 'Pogoj filtra',
	'filter_includesAll': 'Vključuje vse',
	'filter_allMembersOfSet': 'Vsi člani nabora',
	'modelFilter': 'Filter',
	'filtersTitle': 'Lastnosti filtra',
	'search': 'Iskanje',
	'clearTextFilterValue': 'Počisti',
	'invertFilterSelection': 'Obrni',
	'modellingLoading': 'Nalaganje ...',
	'searchAll': 'Najdi vse stolpce',
	'toolbarActionPossibleKeyDrivers': 'Urejanje območja',
	'toolbarActionPossibleKeyDriversSubTitle': 'Povlecite postavke z leve, da bodo upoštevane v grafikonu analize gonilnikov.',
	'toolbarActionSort': 'Razvrsti',
	'toolbarActionSortAscending': 'Naraščajoče',
	'toolbarActionSortDescending': 'Padajoče',
	'toolbarActionSortAuto': 'Samodejno (%{sortOrder})',
	'toolbarActionSortCustom': 'Po meri',
	'toolbarActionFormat': 'Oblika zapisa podatkov',
	'toolbarActionFormatText': 'Oblikuj podatke (besedilo)',
	'toolbarActionFormatAbbreviation': 'Okrajšano',
	'toolbarActionFormatNone': 'Samodejno',
	'toolbarActionFilter': 'Filter',
	'toolbarActionTopBottom': 'Zgoraj ali spodaj',
	'toolbarActionRmvShape': 'Odstrani obliko',
	'toolbarActionToggleShapeDrop': 'Oblika vizualne predstavitve',
	'toolbarActionToggleShapeDropTitle': 'Ustvarite vizualno predstavitev',
	'toolbarActionToggleShapeDropText': 'V to polje povlecite obliko, da ustvarite vizualno predstavitev.',
	'toolbarActionAggregationType': 'Seštej',
	'toolbarDeleteActionText': 'Odstrani stolpec',
	'toolbarTextActionText': 'Besedilo sloga',
	'toolbarActionFilterLocalKeepSelected': 'Ohrani',
	'toolbarActionFilterLocalExcludeSelected': 'Izključi',
	'toolbarActionFilterAllKeepSelected': 'Filter',
	'toolbarActionSimpleCalculation': 'Preprost izračun',
	'toolbarActionDrillBack': 'Nazaj',
	'toolbarActionDrillUp': 'Vrtaj navzgor',
	'toolbarActionDrillDown': 'Vrtaj navzdol',
	'toolbarActionJumpTo': 'Vrtanje počez',
	'toolbarActionNavigate': 'Navigacija',
	'toolbarActionCreateFilterGroup': 'Ustvari novo povezavo',
	'toolbarActionDisconnectFilterGroup': 'Prekini vse povezave',
	'toolbarActionLinkFilterGroup': 'Dodaj v obstoječo povezavo',
	'toolbarActionLassoSelect': 'Orodje za izbiranje',
	'toolbarActionRefreshDeveloperWidget': 'Osveži',
	'textFontFamilySubClassHairline': 'Izjemno tanko',
	'textFontFamilySubClassThin': 'Tanko',
	'textFontFamilySubClassThinItalic': 'Tanko ležeče',
	'textFontFamilySubClassExtraLight': 'Izjemno lahko',
	'textFontFamilySubClassExtraLightItalic': 'Izjemno lahko ležeče',
	'textFontFamilySubClassLight': 'Svetlo',
	'textFontFamilySubClassLightItalic': 'Lahko ležeče',
	'textFontFamilySubClassRegular': 'Običajno',
	'textFontFamilySubClassRegularItalic': 'Običajno ležeče',
	'textFontFamilySubClassItalic': 'Ležeče',
	'textFontFamilySubClassMedium': 'Srednje',
	'textFontFamilySubClassMediumItalic': 'Srednje ležeče',
	'textFontFamilySubClassHeavy': 'Težko',
	'textFontFamilySubClassHeavyItalic': 'Težko ležeče',
	'textFontFamilySubClassDemiBold': 'Srednje krepko',
	'textFontFamilySubClassDemiBoldItalic': 'Srednje krepko ležeče',
	'textFontFamilySubClassBold': 'Krepko',
	'textFontFamilySubClassBoldItalic': 'Krepko ležeče',
	'textFontFamilySubClassExtraBold': 'Zelo krepko',
	'textFontFamilySubClassExtraBoldItalic': 'Zelo krepko ležeče',
	'textFontFamilySubClassBlack': 'Črno',
	'textFontFamilySubClassBlackItalic': 'Črno ležeče',
	'textFontFamilySubClassStencil': 'Šablona',
	'dlg_ascending': 'naraščajoče',
	'dlg_descending': 'padajoče',
	'dlg_custom': 'po meri',
	'dlg_none': 'brez',
	'dlg_hierarchy': 'hierarhija',
	'dlg_namedSet': 'poimenovan nabor',
	'dlg_rank': 'rang',
	'visualizationLabel': 'Vizualizacija',
	'chartLabel': 'Grafikon %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pritisnite F12 za pomikanje znotraj gradnika',
	'f10KeyDescription': 'Pritisnite F10, da zaženete pogled žarišča gradnik',
	'playButtonLabel': 'Predvajaj',
	'dataPlayerValueListLabel': 'Vrednosti predvajalnika podatkov',
	'localFilterTitle': 'Samo ta objekt',
	'globalFilterTitle': 'Vsi objekti',
	'deleteFilter': 'Izbriši filter',
	'editFilter': 'Urejanje filtra',
	'ariaEditFilterLabel': 'Pritisnite tipko ENTER, da uredite filter.',
	'ariaDeleteFilterLabel': 'Pritisnite tipko DELETE, da izbrišete filter.',
	'measureFilterBetween': 'Med %{lowerBound} in %{upperBound}',
	'measureFilterNotBetween': 'Ni med %{lowerBound} in %{upperBound}',
	'dimFilterIn': 'Vključuje: %{in}',
	'dimFilterNotIn': 'Izključuje: %{out}',
	'gtFilter': 'Po %{lowerBound}',
	'ltFilter': 'Pred %{upperBound}',
	'ariaEditPrompt': 'Pritisnite tipko ENTER, da spremenite vrednosti poziva.',
	'dataPointFilterTitle': 'Podatkovne točke',
	'dataPointFilterIncludeSummary': 'Št. vključenih podatkovnih točk: %{valueCount}',
	'dataPointFilterExcludeSummary': 'Št. izključenih podatkovnih točk: %{valueCount}',
	'widgetFiltersLabel': 'Filtri gradnika',
	'coachMarkTitleSpiralTarget': 'Urejanje območja',
	'coachMarkContentSpiralTarget': 'Tukaj lahko dostopate do izbora gonilnikov za svoj cilj in jih spreminjate.',
	'srILVTreeLabel': 'Seznam',
	'geomapUnrecognizedLocations': 'Neprepoznane lokacije:',
	'geomapAmbiguousLocations': 'Dvoumna območja:',
	'visualizationNotifications': 'Obvestila vizualizacije:',
	'dataNotifications': 'Obvestila podatkov:',
	'autobinSuggestion': 'Vklopi samodejno grupiranje',
	'LIVE_empty_visualization_hint_title': 'Zgradite svojo vizualizacijo',
	'LIVE_empty_visualization_hint_description': 'Povlecite podatke sem ali v polja.',
	'LIVE_slots_required_field_description': '%{asterisk} Kaže obvezno polje',
	'LIVE_slots_drag_and_drop_description': 'Povlecite in spustite podatke v polja zgoraj, da zgradite in filtrirate vizualizacijo.',
	'dwErrorLoadingAvailableVisualizations': 'Razpoložljivih definicij vizualizacije ni mogoče naložiti',
	'moreDataIndicator': 'Podatki so bili obrezani pri naslednjem št. postavk: %{threshold}. Uveljavite filter, da se prikaže manj zadetkov.',
	'nonCtxTopBottomInvalid': 'Definiranje zgornjega ali spodnjega pravila brez konteksta ni podprto za navzkrižne tabele. Odstranjeno je bilo iz tega pogleda navzkrižne tabele.  Znova definirajo pravilo za eno ali več kategorij v kontekstu %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Objekta ni mogoče naložiti, ker mu manjka definicija vizualizacije',
	'dwErrorLoadingVisualizationListNotFound': 'Vizualizacije ni mogoče naložiti.',
	'dwErrorRunningQuery': 'Podatkov iz nabora podatkov %{datasetName} ni mogoče pridobiti.',
	'dwErrorGeoData': 'Prišlo je do težav s prikazovanjem geografskih podatkov na zemljevidu. Izberite drug tip vizualizacije.',
	'dwPromptSignonCancelWarning': 'Podatki za to vizualizacijo niso na voljo. Podajte pravilne poverilnice.',
	'dwErrorMissingDataset': 'Vizualizacije ni mogoče naložiti, ker njen povezan nabor podatkov "%{datasetName}" ni na voljo.',
	'dwErrorRenderingVisualization': 'Vizualizacije ni mogoče naložiti.',
	'dwErrorVisualizationTooSmall': 'Vizualizacija je premajhna za prikaz podatkov, ki jih vsebuje. Vizualizacijo naredite večjo ali omejite podatke, ki jih vsebuje.',
	'errorSourceNotFound': 'Vizualizacije ni mogoče naložiti, ker njen povezan izvor "%{sourceName}" ni na voljo.',
	'errorActionNotSupported': 'To dejanje ni podprto za izvor podatkov "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'Vizualizacija ima mere na več robovih, kar ni več podprto. Mere naj bodo samo na enem robu.',
	'errorExceedAllowableValue': 'Ocenjeno število celic prekoračuje dovoljeno vrednost, ki je 100000. Za projicirane nabore uveljavite filtriranje, da zmanjšate število celic.',
	'propScaleLabel': 'Količina ikon',
	'propScaleDescription': 'Izberite količino ikon',
	'propScaleFew': 'Nizka',
	'propScaleDefault': 'Privzeto',
	'propScaleMany': 'Visoka',
	'lastRefresh': 'Zadnja osvežitev: pred %{timeInterval}',
	'widgetTimer': 'Časomer gradnika',
	'datasetItemsUnavailable': 'Nekatere postavke nabora podatkov, uporabljene v tej vizualizaciji, niso na voljo.',
	'datasetItemUnavailable': 'Ta postavka nabora podatkov ni na voljo',
	'retry': 'Poskusi znova',
	'widgetConditionalFormatLabel': 'Preklopi kontrolnike pogojnega oblikovanja',
	'widgetConditionalFormatTitle': 'Urejanje barve pogojnega oblikovanja',
	'crosstabName': 'Navzkrižna tabela',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'Ni na voljo',
	'summaryLabel': '%{label} z vrednostjo %{value}',
	'infographicLabel': '%{label} z vrednostjo %{value}',
	'warning': 'Opozorilo',
	'swapRowsAndColumns': 'Zamenjaj vrstice in stolpce',
	'hideSummariesLabel': 'Skrij povzetke',
	'showSummariesLabel': 'Pokaži povzetke',
	'hideRowColumn': 'Skrij',
	'showAllRowColumn': 'Pokaži vse',
	'dataAssetPropertiesLabel': 'Lastnosti vizualizacije',
	'evAdd': 'Dodaj stolpec',
	'evCollapse': 'Strni',
	'evColumns': 'Stolpci',
	'evLocalFilters': 'Lokalni filtri',
	'evExpand': 'Razširi',
	'evFilterTooltip': 'Filter',
	'missingColumn': 'Manjka: %{columnLabel}',
	'missingFiltering': 'Manjkajoči filtri za stolpce:',
	'missingDataItem': 'Sklicevane podatkovne postavke "%{dataItemId}" ni bilo mogoče najti v gradniku.',
	'heatByLabel': 'Toplotni po',
	'toolbarChangeVisualization': 'Spremeni vizualizacijo',
	'modellingRelatedTablesNoneFound': 'Najdena ni nobena povezana tabela',
	'processing': 'Obdelava ...',
	'errorCellWarning': 'Nekaterih vrednosti povzetka ni bilo mogoče izračunati.',
	'aggregateTypeToggler': 'Pokaži tip agregiranja',
	'maxColumnsExceeded': 'Največje število stolpcev je bilo preseženo. Odstranjeno: %{columns}.',
	'unboundColumns': 'Naslednjih stolpcev ni mogoče uporabiti: %{columns}.',
	'unboundColumn': 'Naslednjega stolpca ni mogoče uporabiti: %{columns}.',
	'recommendRequestFailed': 'Zahteva za priporočilo ni uspela. Obrnite se na skrbnika.',
	'visualizationDoesNotSupportOLAP': 'Te vizualizacije, ki temelji na izvoru podatkov OLAP, ne moremo ustvariti. Uporabite drug podprt izvor podatkov.',
	'showDataBehindVizLabel': 'Pokaži podatke',
	'showDataBehindVizNotSupportedLabel': 'Prikaz podatkov ni podprt za ta tip vizualizacije',
	'exploreData': 'Razišči ...',
	'newExplore': 'Novo raziskovanje',
	'thumbnails_error_fetching': 'Napaka pri pridobivanju sličic',
	'loadedThumbnailImage': 'Sličica naložene vizualizacije %{visType}',
	'autobinAxisLabel': 'skupine',
	'recommended_visualizations': 'Priporočene vizualizacije',
	'all_visualizations': 'Vse vizualizacije',
	'edit': 'Urejanje',
	'selectTargetDialogTitle': 'Izberite cilj vrtanja počez',
	'noTargetInCM': 'Cilja vrtanja počez ni mogoče najti',
	'errorDrillDefinition': 'Med dodajanjem ali brisanjem definicije vrtanja počez je šlo nekaj narobe.',
	'errorDrillToTarget': 'Prišlo je do napake pri vrtanju na "%{targetName}"',
	'drillThroughMappingViewLabel': 'Dodelite stolpce z delovne table pozivom ciljnega poročila',
	'drillthroughScopeRadioLabel': 'Uveljavi to definicijo za:',
	'drillthroughScopeRadioOptionVisualization': 'Samo ta vizualizacija',
	'drillthroughScopeRadioOptionConnection': 'Vizualizacije v isti povezavi, ki uporabljajo isti izvor podatkov',
	'drillthroughScopeRadioOptionDashboard': 'Katerakoli vizualizacija na %{perspective}, ki uporablja isti izvor podatkov',
	'drillThroughParametersColumnTitle': 'Pozivi za "%{targetName}":',
	'drillThroughMetadataColumnTitle': 'Podatkovni stolpci "%{boardName}":',
	'drillThroughDefinitionNoParameter': 'Cilj vrtanja počez nima pozivov.',
	'drillThroughDefinitionErrorQueryingReport': 'Odpravite težavo s ciljnim poročilom in poskusite znova, da ustvarite definicijo vrtanja počez.',
	'drillThroughDefinitionErrorDlgTitle': 'Prišlo je do napake',
	'dlg_back': 'Pojdi nazaj',
	'dlg_close': 'Zapri',
	'dlg_ok': 'V redu',
	'dlg_cancel': 'Prekliči',
	'dlg_apply': 'Uveljavi',
	'dlg_create': 'Ustvari',
	'dlg_done': 'Opravljeno',
	'drillthrough_unsaveMsg': 'Želite nadaljevati, ne da bi shranili "%{name}"?',
	'drillthrough_jumpTo': 'Definicija vrtanja počez: %{name}',
	'drillthrough_jumpToLabel': 'Vrtanje počez',
	'drillthrough_manage': 'Upravljanje ...',
	'drillthrough_addNewTarget': 'Dodaj novo definicijo vrtanja počez',
	'drillthrough_manageJumpPaths': 'Upravljanje definicij vrtanja počez',
	'drillthrough_manageJumpPaths_edit': 'Urejanje "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Izbriši "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Dodaj drugo definicijo vrtanja počez',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Potrdi brisanje',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Ali ste prepričani, da želite izbrisati vrtanje počez "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Podvojeno ime vrtanja počez',
	'drillthrough_definitionMessage': 'Vrtanje počez "%{name}" že obstaja. Podajte drugo ime.',
	'drillthrough_jumpToTarget_notFound': 'Cilja ni bilo mogoče najti za vrtanje počez "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'V ciljno poročilo ne bo posredovan noben kontekst.',
	'drillthrough_titleLabel': 'Ime',
	'drillthrough_create_dialogTitle': 'Ustvari definicijo vrtanja počez',
	'drillthrough_edit_dialogTitle': 'Urejanje definicije vrtanja počez',
	'drillthrough_subTitle': 'Kontekst vizualizacije v izvoru se uporablja za filtriranje ciljnega %{perspective}.',
	'drillthrough_selectColumn': 'Izberi stolpec',
	'noPrompt': 'Ni pozivov',
	'promptDialog': 'Pogovorno okno poziva %{promptType}',
	'formatAutoDescription': 'Samodejno podaja format, ki je podedovan od izvora podatkov ali vizualizacije.',
	'formatDefaultDescription': 'Privzeto podaja format, ki je podedovan od sistema',
	'createCustomGroupAction': 'Ustvari podatkovno skupino',
	'removeCustomGroupAction': 'Odstrani podatkovno skupino',
	'editCustomGroupAction': 'Urejanje podatkovne skupine',
	'renameCustomGroupAction': 'Preimenuj podatkovno skupino',
	'createCustomGroupErrorToast': 'Podatkovne skupine ni bilo mogoče ustvariti.',
	'removeCustomGroupErrorToast': 'Podatkovne skupine ni bilo mogoče odstraniti.',
	'editCustomGroupErrorToast': 'Podatkovne skupine ni bilo mogoče urediti.',
	'renameCustomGroupErrorToast': 'Podatkovne skupine ni bilo mogoče preimenovati.',
	'customGroupLabel': 'Ustvari podatkovno skupino',
	'ungroupCustomGroupLabel': 'Razgrupiraj',
	'renameCustomGroupLabel': 'Preimenuj',
	'createCustomGroupLabel': 'Ustvari',
	'customGroupingLabel': '%{columnLabel} (skupina)',
	'createCustomSort': 'Ustvari vrstni red po meri',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Izberite razpoložljive postavke, nato pa jih prerazvrstite, da ustvarite vrstni red po meri.',
	'availableItems': 'Razpoložljive postavke',
	'selectAll': 'Izberi vse',
	'customSortOrder': 'Vrstni red razvrščanja po meri',
	'selectAvailableItemsDesc': 'Izberite razpoložljive postavke, nato pa jih prerazvrstite tukaj.',
	'moveToTop': 'Premakni na vrh',
	'clear': 'Počisti',
	'sortRemainingItemsBy': 'Razvrsti preostale postavke po',
	'removeAll': 'Odstrani vse',
	'resetTooltip': 'Vse postavke bodo odstranjene s seznama %{customSortOrder}. Spustni seznam %{sortRemainingItemsBy} se bo vrnil na privzete vrednosti.',
	'manyItemsWarning': 'Če izberete veliko postavk, to lahko vpliva na delovanje delovne table.',
	'manyItemsSelected': 'Izbrano je bilo več kot toliko postavk: %{maxItems}, kar lahko vpliva na zmogljivost delovne table.',
	'somethingWentWrong': 'Ojej. Nekaj ni v redu. ',
	'tryAgain': 'Poskusite znova',
	'customSortLabel': 'Vrstni red po meri',
	'applyError': '%{action} ni mogoče uveljaviti.',
	'searchReturnedNoResults': 'Iskanje ni vrnilo rezultatov.',
	'extVisSystem': 'Sistem',
	'extVisCustom': 'Po meri',
	'customVisTestVisualization': 'Preizkusi vizualizacijo',
	'extVisCustomVisPreview': 'predogled',
	'extVisCustomPreviewWidgets': 'Gradniki za razvijalce',
	'extVisCustomVVisualization': 'Vizualizacija',
	'extVisCustomVisuals': 'Vizualizacije po meri',
	'noPermissionToManage': 'Nimate dovoljenja za upravljanje vizualizacij po meri.',
	'extVisCustomUpdate': 'Posodobi',
	'extVisCustomDelete': 'Izbriši',
	'extVisNoCustomVisuals': 'Ni vizualizacij po meri',
	'extVisNoCustomVisualsMsg': 'V vaši organizaciji trenutno ni vizualizacij po meri',
	'extVisAddCustomVisual': 'Dodaj vizualizacijo po meri',
	'extVisNoCustomVisualsAdminMsg': 'Trenutno ni vizualizacij po meri. Za začetek dodajte eno',
	'extVisNoSDKConnection': 'Za vašo lokalno datoteko ni bila ustvarjena nobena povezava',
	'extVisNoSDKPreviewMsg': 'Če si želite predogledati vizualizacije, vzpostavite povezavo.',
	'extVisMore': 'Več',
	'extVisDeleteDialogTitle': 'Izbriši vizualizacijo po meri',
	'extVisDeleteDialogBody': 'Ali ste prepričani, da želite izbrisati to vizualizacijo po meri? Morda jo uporabljajo druge delovne table in poročila.',
	'extVisDeleteConfirmation': 'Vizualizacija po meri je bila izbrisana.',
	'extVisDeleteError': 'Vizualizacije po meri ni bilo mogoče izbrisati. %{msg}',
	'extVisCloseToast': 'Zapri zdaj',
	'extVisAdd': 'Vizualizacija po meri je bila uspešno dodana.',
	'extVisAddError': 'Vizualizacije po meri ni bilo mogoče dodati. %{msg}',
	'extVisUpdate': 'Vizualizacija po meri je bila uspešno posodobljena.',
	'extVisUpdateError': 'Vizualizacije po meri ni bilo mogoče posodobiti. %{msg}',
	'extVisAddProgress': 'Uvažanje %{name}',
	'extVisUpdateProgress': 'Posodabljanje %{name}',
	'extPermissionTitle': 'Omejen dostop ali izbrisana vizualizacija po meri',
	'extPermissionBody': 'Te vizualizacije po meri si ni mogoče ogledati, ker je bila izbrisana ali ker ima omejen dostop.',
	'customVizSaveWarning': 'Vašega sloga ni bilo mogoče shraniti. Vizualizacije niso bile uvožene.',
	'schematicTestCaption': 'Preizkusi shemo',
	'schematicServiceRequestError': 'Napaka storitve sheme',
	'extVisPreviewMessage': 'To je predogled. Vizualizacija še ni bila dodana v izdelek.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Nedefinirano',
	'kpiDefaultTargetLabel': 'Cilj',
	'kpiNonNumericTarget': 'Ciljna vrednost mora biti število.',
	'kpiManualTargetSlotFilled': 'Vrednost je uveljavljena v polju',
	'kpiAutoValueSize': 'Samodejno',
	'kpiUnableDrawSparklineLabel': 'Grafikona sparkline ni mogoče narisati',
	'kpiUnableDrawSparklineInfo': 'Grafikon sparkline zahteva najmanj dve točki v času. Spremenite podatke ali prilagodite filtre, da si ogledate grafikon sparkline.',
	'conditionalFormattingTextColor': 'Barva besedila',
	'suppression': 'Izločitev',
	'suppressNone': 'Brez',
	'suppressRowsAndColumns': 'Vrstice in stolpci',
	'suppressRows': 'Vrstice',
	'suppressColumns': 'Stolpci',
	'enableSuppression': 'Omogoči izločitev',
	'disableSuppression': 'Onemogoči izločitev',
	'loadVisDefinitionError': 'Definicije za vizualizacijo %{id} ni mogoče naložiti',
	'emptyVisualization': 'Prazna vizualizacija',
	'expandCollapse': 'Razširi in strni',
	'expandBtnLabel': 'Razširi',
	'collapseBtnLabel': 'Strni',
	'prop_sizeInputNonNumericValue': 'Vrednost mora biti število.',
	'prop_sizeValueShouldBeHigher': 'Vrednost mora biti večja od %{value}.',
	'fontPropLabel': 'Družina pisav',
	'fontSizePropLabel': 'Velikost pisave',
	'sectionItemAxisTitle': 'Naslov osi postavke',
	'sectionItemAxisLabel': 'Oznaka osi postavke',
	'sectionValueAxisTitle': 'Naslov osi vrednosti',
	'sectionValueAxisLabel': 'Oznaka osi vrednosti',
	'styletext-widget.legend': 'Legenda',
	'styletext-itemAxis.ticks.labels': 'Oznake osi',
	'styletext-valueAxis.title': 'Naslovi osi',
	'styletext-itemAxis.title': 'Naslovi osi',
	'styletext-labels': 'Podatkovne oznake',
	'styletext-valueAxis.line.title': 'Naslovi vrstic',
	'styletext-cellValue': 'Vrednosti',
	'styletext-values': 'Vrednosti',
	'styletext-rowHeading': 'Naslovi vrstic',
	'styletext-columnHeading': 'Naslovi stolpcev',
	'fontFamily': 'družina',
	'fontSize': 'velikost',
	'visExportFileName': 'Vizualizacija',
	'ds-missingDataSet': 'Nabora podatkov ni bilo mogoče najti. Prepričajte se, da je bil nabor podatkov uspešno ustvarjen.',
	'ds-missingDashboardId': 'Shranite delovno tablo, preden ustvarite nabor podatkov.',
	'ds-unsupportedDataSourceType': 'Tip izvora podatkov %{type} ni podprt.',
	'dataCache': 'Predpomnilnik podatkov',
	'dataCache_on': 'Vključeno',
	'dataCache_off': 'Ni predpomnilnika',
	'dataCache_auto': 'Samodejno',
	'queryOptimization': 'Optimizacija poizvedb'
});
